var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.companyCode)?_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.top",modifiers:{"hover":true,"top":true}}],staticClass:"badge badge-pill",style:({ backgroundColor: _vm.badgeColor, color: '#fff' }),attrs:{"title":_vm.companyName || _vm.companyCode}},[_vm._v(_vm._s(_vm.companyCode))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }